var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"img_banner2"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"banner2"},[_c('h3',{staticClass:"titulo_banner_2"},[_vm._v("Toda a segurança do seu condomínio em um sistema")]),_c('h1',[_vm._v("interativo, prático e seguro !")])])])])
}]

export { render, staticRenderFns }